import React from 'react';
import Flag from '@asphalt-react/flag';

function UnauthorizedAccessPage() {
    return (
        <div
            style={{
                width: '100%',
            }}>
            <Flag noTitle banner title='You do not have access to this page.' />
        </div>
    );
}

export default UnauthorizedAccessPage;
